import { CellRenderer } from 'components/table/types';
import { DateTime } from 'luxon';
import { ISO6391LanguageCode } from 'shared/types/locale';
import {
  toIssueDateDisplayStringFormat,
  toIssueDateTimeDisplayStringFormat,
  toLocalizedDateDisplayStringFormat,
  toLocalizedDateDisplayStringFormatWithTime,
  toStandardDateDisplayStringFormat,
} from 'shared/utils/date/dates';

export const displayDate = (
  date: DateTime | null | undefined | string,
  timezone: string
): null | string => {
  if (!date) {
    return null;
  }

  return toStandardDateDisplayStringFormat(date, timezone);
};

export const displayIssueDate = (
  date: DateTime | null | undefined | string,
  timezone: string
): null | string => {
  if (!date) {
    return null;
  }

  return toIssueDateDisplayStringFormat(date, timezone);
};

export const displayIssueDateTime = (
  date: DateTime | null | undefined | string,
  timezone: string
): null | string => {
  if (!date) {
    return null;
  }

  return toIssueDateTimeDisplayStringFormat(date, timezone);
};
export const displayLocalizedDate = (
  date: DateTime | null | undefined | string,
  timezone: string,
  locale: ISO6391LanguageCode
): null | string => {
  if (!date) {
    return null;
  }

  return toLocalizedDateDisplayStringFormat(date, timezone, locale);
};

export const displayDateWithTime = (
  date: DateTime | null | undefined | string,
  timezone: string,
  locale: ISO6391LanguageCode
): null | string => {
  if (!date) {
    return null;
  }

  return toLocalizedDateDisplayStringFormatWithTime(
    date,
    timezone,
    locale
  );
};

// PT-7000: issue table datetime columns use a fixed dd.MM.yyyy HH:mm format.
export function createCellModificationDate(
  timezone: string,
  _locale: ISO6391LanguageCode
): CellRenderer<{ modifiedAt: DateTime }> {
  return ({ rowData }): string | null => {
    return displayIssueDateTime(rowData.modifiedAt, timezone);
  };
}

export function createCellCreationDate(
  timezone: string,
  _locale: ISO6391LanguageCode
): CellRenderer<{ createdAt: DateTime }> {
  return ({ rowData }): string | null => {
    return displayIssueDateTime(rowData.createdAt, timezone);
  };
}

export function createCellExecutionDate(
  timezone: string,
  locale: ISO6391LanguageCode
): CellRenderer<{ inspectionDate: DateTime }> {
  return ({ rowData }): string | null => {
    return displayLocalizedDate(rowData.inspectionDate, timezone, locale);
  };
}
